import styled from 'styled-components';
import { Button, Form } from 'semantic-ui-react';

export const RecipientsFormGroup = styled(Form.Group)`
  align-items: baseline;
`;

export const RecipientWrapper = styled.div`
  border-radius: 10px !important;
  padding: 12px;
  position: relative;
  display: flex;
  align-items: baseline;
  margin-bottom: 10px;
  margin-top: 10px;
   .ui.form .field .ui.input input, .ui.form .fields .field .ui.input input {
     max-width: 300px !important;
   }
`;

export const StyledDeleteButton = styled(Button)`
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: ${props => props.rightAlign ? `${props.rightAlign}px` : '0'};
`;
